import {
  GET_AUTHORS_HEADERS_REQUEST,
  GET_AUTHORS_HEADERS_SUCCESS,
  GET_AUTHORS_HEADERS_FAILURE,
} from 'Store/constants';
    
const initialState = {
  data: {},
  isLoading: null,
  error: null,
};
    
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_AUTHORS_HEADERS_REQUEST:
      return { ...state, isLoading: true, error: null };
    
    case GET_AUTHORS_HEADERS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    
    case GET_AUTHORS_HEADERS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    
    default:
      return state;
  }
};
    